import styled from 'styled-components';

import bkImg from 'ui/assets/img/bg-partner-definitive.webp';
import logoImg from 'ui/assets/img/logos/f-2-mes-logo.svg';

import { pxToRem } from 'utils/scss';

export const AccessWrapper = styled.div`
  background: url(${bkImg});
  background-position: top left;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const AccessPane = styled.div`
  width: ${pxToRem('573px')};
  height: ${pxToRem('620px')};
  box-shadow: 0 ${pxToRem('42px')} ${pxToRem('84px')} 0
    ${({ theme }) => theme.colors.black.seven};
  border-radius: ${pxToRem('46px')};
  border: ${pxToRem('2px')} solid rgba(255, 255, 255, 0.52);
  position: relative;

  @media screen and (max-width: ${pxToRem('572px')}) {
    width: 100%;
    padding: ${pxToRem('25px')} ${pxToRem('36px')};
  }
`;
export const Blur = styled.div`
    //filter: blur(${pxToRem('22px')}) opacity(0.2);
  filter:  opacity(0.2);
  background: white;
  position: absolute;
  width: 100%;
  min-height: 100%;
  border-radius: ${pxToRem('46px')};
  z-index: 0;
`;

export const Foreground = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: ${pxToRem('48px')} ${pxToRem('109px')};
  padding-top: ${pxToRem('65px')}
  height: 100%;
  position: absolute;
  z-index: 2;
`;

export const RowCentered = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const LogoOuterWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: ${pxToRem('-60px')};
  width: ${pxToRem('122px')}
  height: ${pxToRem('122px')}
  background-color: #00b189;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 2px solid white;
  z-index: 2;
`;

export const Logo = styled.div`
  background: url(${logoImg});
  background-size: contain;
  background-repeat: no-repeat;
  width: ${pxToRem('88px')};
  height: ${pxToRem('88px')};
  z-index: 10;
`;

const IconControl = styled.div`
  border: ${pxToRem('2px')} solid #d4d4d5;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${pxToRem('12px')};
  cursor: pointer;
  width: ${pxToRem('48px')};
  height: ${pxToRem('48px')};
  color: ${({ theme }) => theme.colors.buttonTextColor};
  background-color: ${({ theme }) => theme.colors.iconBackgroundGray};
  position: absolute;
`;

export const CloseIcon = styled(IconControl)`
  top: 0;
  right: -${pxToRem('126px')};
`;
export const BackIcon = styled(IconControl)`
  top: 0;
  left: -${pxToRem('126px')};
`;
